import React from 'react';

const DoseTermsExplainer: React.FC = () => {
  return (
    <div className="concepts-box">
      <h3 className="light-text">Help Me Understand!</h3>
      <p className="light-text">
        <i>
          Some key concepts to help you understand your prescription, and how the dosage units are calculated. No math
          needed.
        </i>
      </p>

      <div className="concept-item">
        <strong>Dosage (mg)</strong>The amount of medication you want to take, measured in milligrams (mg). This is not
        the same as the volume of liquid you need to inject!
      </div>
      <div className="concept-item">
        <strong>Volume (mL)</strong>The amount of liquid that contains the medication, measured in milliliters (mL). The
        dosage in a given volume is indicated by the concentration.
      </div>
      <div className="concept-item">
        <strong>Concentration (mg/mL)</strong>This is how much medication (in milligrams) is present per milliliter of
        liquid. For example, if the concentration is 10 mg/mL, it means there are 10 milligrams of medication in each
        milliliter of liquid.
      </div>
      <div className="concept-item">
        <strong>Units</strong>Units are another measure of volume, used to define the amount to pull into your syringe.
        On a typical (U-100) syringe, there are 100 units in 1 milliliter (mL). So 0.5 mL would be 50 units.
      </div>
    </div>
  );
};

export default DoseTermsExplainer;
